<template>
  <v-tooltip text="Find current or archived vehicles by VIN." location="top">
    <template #activator="{ props: tooltipProps }">
      <v-btn
        v-bind="tooltipProps"
        variant="outlined"
        color="primary"
        prepend-icon="mdi-car-search"
        class="text-none"
        @click="openDialog"
      >
        Advanced Vehicle Lookup
      </v-btn>
    </template>
  </v-tooltip>

  <AdvancedVehicleLookupDialog v-model="dialogOpen" />
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import AdvancedVehicleLookupDialog from '@/components/inventory/AdvancedVehicleLookupDialog.vue'

const dialogOpen = ref(false)

const openDialog = () => {
  dialogOpen.value = true
}
</script>
